// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBJD_3U2aOfOHuIm_L_aakeWvvSb8LZxgs',
    authDomain: 'xerovit-web.firebaseapp.com',
    databaseURL: 'https://xerovit-web.firebaseio.com',
    projectId: 'xerovit-web',
    storageBucket: 'xerovit-web.appspot.com',
    messagingSenderId: '830436035902',
    appId: '1:830436035902:web:aac79185de0e67be9ef06f',
    measurementId: 'G-F25QBN9ZZ6',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
